import Icon from '@uikit/components/Icon/Icon';
import Stack from '@uikit/components/Stack/Stack';
import { ReactComponent as AppIcon } from '../../assets/images/easygo-app-icon.svg';
import { AppScreens } from '../AppScreens/AppScreens';
import {
  AppleAppStoreButton,
  GooglePlayStoreButton,
} from '../AppStoreButtons/AppStoreButton';
import { Benefit } from '../Benefit/Benefit';
import styles from './Stage.module.scss';

export const Stage = () => {
  const title = 'Die easyGo App von enercity';

  return (
    <div className={styles.base}>
      <div className={styles.wrapper}>
        <Stack
          gap="1.5rem"
          justifyContent="center"
          alignItems="center"
          flexDirection="row"
          wrap={true}
        >
          <AppIcon className={styles.appIcon} width={56} height={56} />
          <h2 className={styles.subtitle}>Ihr Begleiter im E-Auto Alltag</h2>
        </Stack>

        <h1 className={styles.title}>{title}</h1>

        <Stack
          gap={{ initial: '0.5rem', md: '6.5rem', sm: '1.5rem' }}
          justifyContent="center"
          alignItems="center"
          flexDirection={{ initial: 'column', sm: 'row' }}
        >
          <Benefit>
            <Icon variant="action/info-checkmark" size="iconSize24" />
            <span>Transparente Preise</span>
          </Benefit>
          <Benefit>
            <Icon variant="action/info-checkmark" size="iconSize24" />
            <span>Alles auf einen Blick</span>
          </Benefit>
          <Benefit>
            <Icon variant="action/info-checkmark" size="iconSize24" />
            <span>Deutschlandweit laden</span>
          </Benefit>
        </Stack>
      </div>

      <Stack
        gap="0.5rem"
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
        wrap={true}
      >
        <GooglePlayStoreButton clickContext={title} />
        <AppleAppStoreButton clickContext={title} />
      </Stack>

      <AppScreens />
    </div>
  );
};
